"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultBoxType = void 0;
var ResultBoxType = /** @class */ (function () {
    function ResultBoxType(uri, label, icon) {
        this.uri = uri;
        this.label = label;
        this.icon = icon;
    }
    return ResultBoxType;
}());
exports.ResultBoxType = ResultBoxType;
